import sprite1 from "../assets/figma-admin/admin-metrics-1.svg?raw"
import sprite2 from "../assets/figma-admin/admin-metrics-2.svg?raw"
import sprite3 from "../assets/figma-admin/admin-metrics-3.svg?raw"

export type AdminMetricKey =
  | "balance"
  | "income"
  | "users"
  | "numbers"
  | "garages"
  | "autoclans"
  | "companions"
  | "qrcodes"
  | "shared"
  | "transitions"
  | "signals"
  | "urgent"
  | "road"
  | "personal"
  | "autotrade"
  | "pitstop"
  | "insurance"
  | "autohelp"

export type AdminPlatform = "android" | "ios"

const SPRITE_BY_KEY: Record<AdminMetricKey, string> = {
  balance: sprite1,
  income: sprite1,
  users: sprite1,
  numbers: sprite1,
  garages: sprite1,
  autoclans: sprite1,
  companions: sprite2,
  qrcodes: sprite2,
  shared: sprite2,
  transitions: sprite2,
  signals: sprite2,
  urgent: sprite2,
  road: sprite3,
  personal: sprite3,
  autotrade: sprite3,
  pitstop: sprite3,
  insurance: sprite3,
  autohelp: sprite3,
}

function symbolMarkup(source: string, id: string) {
  const match = source.match(new RegExp(`<symbol id="${id}"[^>]*>([\\s\\S]*?)<\\/symbol>`))
  if (!match) throw new Error(`Missing Admin metric symbol: ${id}`)
  return match[1].replace(
    /<path(?=[^>]*\bstroke=)(?![^>]*\bfill=)/g,
    '<path fill="none"',
  )
}

export function AdminMetricIcon({ platform, metric }: { platform: AdminPlatform; metric: AdminMetricKey }) {
  const markup = symbolMarkup(SPRITE_BY_KEY[metric], `${platform}-${metric}`)
  return (
    <svg
      className="bbf-admin-metric-icon"
      viewBox="0 0 20 20"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  )
}
